import { Component, Input } from '@angular/core';
import { ContainerComponent } from '../container/container.component';
import { RouterLink } from '@angular/router';
import { RegulatoryActivityModel } from '../../../models/regulatory-activity.models';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-regulatory-activity-list',
  imports: [ContainerComponent, RouterLink, DatePipe],
  templateUrl: './regulatory-activity-list.component.html',
  standalone: true,
  styleUrl: './regulatory-activity-list.component.scss',
})
export class RegulatoryActivityListComponent {
  @Input() prdList: RegulatoryActivityModel[] = [];
}
